import { styled } from "@mui/system";
export const StyledFormConfirm = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    maxWidth: theme.constants.containerWidth,
    boxSizing: "border-box",
    marginBottom: 0
  },
  "& .centeredContainer": {
    marginTop: 0,
    "&.title": {
      marginTop: 0,
      fontSize: 20
    }
  },
  "& .heading": {
    fontSize: 48,
    lineHeight: "56px"
  }
}));
